import { BaseIdentifiers, TimeIdentifiers } from '../../common/identifiers';

export enum AffiliateCommissionStatus {
  Paid = 'paid',
  Cancelled = 'cancelled',
  Pending = 'pending',
  Approved = 'approved',
}

export type AffiliationCommission = BaseIdentifiers &
  TimeIdentifiers & {
    userId: string;
    userName: string;
    affiliateId: string;
    affiliateEmail: string;
    externalId: string;
    dueAt: Date;
    purchaseDate?: Date;
    amount: number;
    status: AffiliateCommissionStatus;
    note?: string;
    purchaseCode?: string;
    currency?: string;
  };

export type AffiliateCommissionResponse = {
  id: number;
  date: string;
  due_at: string;
  amount: string;
  currency: string;
  payment_type: string;
  custom_singular: string;
  custom_plural: string;
  cancelled: boolean;
  note?: string;
  paid: boolean;
  purchase?: AffiliateCommissionPurchase;
  affiliate: {
    id: number;
    email: string;
  };
};

export type AffiliateCommissionPurchase = {
  id: number;
  created_at: string;
  updated_at: string;
  cancelled: boolean;
  currency: string;
  purchase_code: string;
  note?: string;
  purchase_amount: string;
  commission_amount_override: string | null;
  cancellation: {
    id: number;
    cancellation_code: string;
    effective_date: string;
    source: string | null;
  };
  lead: {
    id: number;
    email: string;
  };
  affiliate: {
    id: number;
    email: string;
  };
  plan: {
    id: number;
    code: string;
  };
};

export type AffiliateCommissionWithFilterResponse = {
  total_entries: number;
  commissions: AffiliateCommissionResponse[];
};
